import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { DownloadManagementComponent } from './download-management.component';
import { DownloadService } from '@fuse/services/download/download.service';
import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule } from '@angular/material';
import { DownloadListComponent } from './download-list/download-list.component';

const routes = [
    {
        path: 'download',
        component: DownloadManagementComponent
    }
];

@NgModule({
    declarations: [
        DownloadManagementComponent,
        DownloadListComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule
    ],
    providers: [
        DownloadService
    ],
    exports: [
        DownloadManagementComponent
    ]
})

export class DownloadManagementModule {
}
